/**
 * 机型 -> 适配机型id map
 * 由于当前并不能从【套餐】直接获取到【适配机型id】
 * 所以需要先【套餐】关联到【产品】
 * 再由【产品】关联到【适配机型id】
 * 这层关系暂时维护在前端，后端目前没有维护这层关系@彭越
 */
export const supportedAdapterIdMap: Record<number, { urlKey: string; adapterId: number }> = {
  // 目前只开放x3、x4
  19: {
    urlKey: 'x3',
    adapterId: 36,
  },
  26: {
    urlKey: 'x4',
    adapterId: 41,
  },
  // 以下商品不开放
  // 4: {
  //   urlKey: 'one',
  //   adapterId: 28,
  // },
  // 6: {
  //   urlKey: 'Pro_2',
  //   adapterId: 28,
  // },
  // 7: {
  //   urlKey: 'one_x',
  //   adapterId: 23,
  // },
  // 10: {
  //   urlKey: 'titan',
  //   adapterId: 29,
  // },
  // 13: {
  //   urlKey: 'one_x2',
  //   adapterId: 25,
  // },
  // 14: {
  //   urlKey: 'go-2',
  //   adapterId: 26,
  // },
  // 15: {
  //   urlKey: 'one_rs',
  //   adapterId: 31,
  // },
  // 17: {
  //   urlKey: 'one_rs_1_inch_360',
  //   adapterId: 32,
  // },
  // 18: {
  //   urlKey: 'link',
  //   adapterId: 35,
  // },
  // 22: {
  //   urlKey: 'flow',
  //   adapterId: 37,
  // },
  // 24: {
  //   urlKey: 'go-3',
  //   adapterId: 38,
  // },
  // 25: {
  //   urlKey: 'ace-pro',
  //   adapterId: 39,
  // },
  // 27: {
  //   urlKey: 'go-3s',
  //   adapterId: 42,
  // },
  // 28: {
  //   urlKey: 'flow-pro',
  //   adapterId: 43,
  // },
  // // 这款产品没有配件，注意一下
  // 29: {
  //   urlKey: 'link-2',
  //   adapterId: 44,
  // },
  // 30: {
  //   urlKey: 'ace-pro-2',
  //   adapterId: 46,
  // },
  // 31: {
  //   urlKey: 'connect',
  //   adapterId: 69,
  // },
};

/** 通过urlKey获取适配信息 */
export function getAdapterByUrlKey(urlKey: string) {
  const adapterInfo = Object.entries(supportedAdapterIdMap).find(([, item]) => {
    return item.urlKey === urlKey;
  });

  return adapterInfo ? adapterInfo[1] : undefined;
}
